export default function SVG_Polygon() {
  return (
    <div>
      <h1>SVG_Polygon Component</h1>
    </div>
  );
}
